import {
  buildSelectionSummaryLabel,
  collectVisibleLeaves,
  countSelectedServices,
  hasVisibleLeaves,
  isAllLeavesSelected,
} from '@/controller/topics/topicRelationsSelection';

/**
 * お知らせ一斉配信の配信先選択モーダル（views/topics/include/topic_relations_select.html）。
 * ツリーの取得と1件ずつの選択は共用の multiSelectCtrl が担い、ここはお知らせ固有の表示だけ持つ。
 *
 * scope は topicEditCtrl > 本コントローラ > multiSelectCtrl の3階層。
 * ツリーは一番内側にあるので、テンプレートから引数で受け取る（inArray と同じ）。
 *
 * @param {*} $scope
 * @param {*} $translate
 */
function topicRelationsSelectCtrl($scope, $translate) {
  $scope.hasVisibleLeaves = hasVisibleLeaves;
  $scope.isAllLeavesSelected = isAllLeavesSelected;

  $scope.hasChildrenLeaves = function (services, childrenKey, searchString) {
    return (services || []).some(function (service) {
      return hasVisibleLeaves(service[childrenKey], searchString);
    });
  };

  /**
   * 表示中の末端をまとめて選択 / 解除する。すべて選択済みなら解除、それ以外は全て選択。
   * 行ごとの反転ではなく force を渡すことで、施設をまたいでも状態が揃う。
   *
   * @param {Object|Array} nodes 施設 / 学年ノード（配列も可）
   * @param {string} searchString 検索文字列
   * @param {string} kind 'groups' | 'members'
   */
  $scope.toggleLeaves = function (nodes, searchString, kind) {
    var isMembers = kind === 'members';
    var leaves = collectVisibleLeaves(nodes, searchString);
    if (!leaves.length) {
      return;
    }
    var selectedIds = isMembers ? $scope.members_selected : $scope.groups_selected;
    var add = !isAllLeavesSelected(nodes, searchString, selectedIds);

    var relationObjects = leaves.map(function (leaf) {
      if (isMembers) {
        return { id: leaf.id, label: leaf.name };
      }
      return {
        id: leaf.value.id,
        label: leaf.value.name,
        category_label: leaf.value.category_name,
        service_id: leaf.value.service_id,
      };
    });

    // 1件ずつのコールバックだと配信先リストの複製と全走査が件数ぶん走るので、まとめて渡す
    $scope.bulk_select_callback(
      relationObjects,
      isMembers ? $scope.system.TOPIC_RELATIONS_KIND_MEMBER : $scope.system.TOPIC_RELATIONS_KIND_GROUP,
      add
    );
  };

  $scope.getSelectedServiceCount = function (groups, members) {
    return countSelectedServices(groups, members, $scope.groups_selected, $scope.members_selected);
  };

  $scope.getSelectionSummaryLabel = function (groups, members, memberLabel) {
    return buildSelectionSummaryLabel(
      $scope.getSelectedServiceCount(groups, members),
      ($scope.groups_selected || []).length,
      ($scope.members_selected || []).length,
      $scope.getSize(groups) > 1,
      memberLabel
    );
  };

  $scope.selectTab = function (value) {
    $scope.target = value;
  };

  var translate = function (key) {
    return $translate.instant(key);
  };
  var showMembers = $scope.inArray('members', $scope.targets);
  $scope.select_tabs = [
    { value: 'groups', label: 'クラス', hidden: !$scope.inArray('groups', $scope.targets) },
    { value: 'members', label: translate('園児'), testId: 'member', hidden: !showMembers },
    {
      value: 'before_admission_members',
      label: translate('入園') + '前' + translate('園児'),
      hidden: !showMembers || $scope.members_search.ignore_open_date_flag != $scope.system.FLAG_ON,
    },
    {
      value: 'retire_members',
      label: translate('卒退園児'),
      hidden: !showMembers || $scope.members_search.include_login_limit_flag != $scope.system.FLAG_ON,
    },
  ];
}

angular.module('inspinia').controller('topicRelationsSelectCtrl', topicRelationsSelectCtrl);
